import { Location } from '@apis/index'
import { booking, edit, switchOff, switchOn } from '@assets/icons'
import Svg from '@components/svg'
import Table from '@components/table'
import useScrollToTop from '@hooks/useScrollToTop'
import { RootState } from '@store/index'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ImageContainer, ImageWrapper, LocationImage, NoImage } from './style'

const LocationSetupList = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const scrollToTop = useScrollToTop()
  const {
    items: Locations,
    totalItems,
    totalPages,
    loading,
  } = useSelector((state: RootState) => state.location)
  console.log(Locations, 'location')
  const navigate = useNavigate()
  const [page, setPage] = useState(1)

  const fetchLocation = async (search = '', page = 1) => {
    await Location.list({
      state: 'location',
      params: { page, limit: 20, search },
    })
  }
  useEffect(() => {
    setPage(1)
  }, [searchTerm])

  useEffect(() => {
    fetchLocation(searchTerm, page)
  }, [page, searchTerm])

  const columns = [
    {
      title: 'Featured Image',
      key: 'image',
      render: (item: any) => (
        <ImageWrapper>
          <ImageContainer>
            {item?.image ? (
              <LocationImage
                src={`${process.env.APP_BUCKET_URL}/${item.image}`}
                alt={item.name || 'Location Image'}
              />
            ) : (
              <NoImage>No Image</NoImage>
            )}
          </ImageContainer>
        </ImageWrapper>
      ),
    },
    {
      title: 'Location Name',
      key: 'locationName',
      render: (item: any) => <p>{item?.name || '-'}</p>,
    },
    {
      title: 'Base Price',
      key: 'basicPrice',
      render: (item: any) =>
        item?.minPrice !== undefined && item?.minPrice !== null
          ? `₹${item.minPrice}`
          : '-',
    },
    {
      title: 'Boarding/Dropoff Points',
      key: 'boardingPointsList',
      render: (item: any) =>
        item?.points?.length ? `${item.points.length}+ points` : '0 points',
    },
    {
      title: 'Is Popular',
      key: 'isPopular',
      render: (item: any) => (
        <Svg
          src={item?.isPopular ? switchOn : switchOff}
          onClick={async () => {
            const payload = { isPopular: !item?.isPopular }
            await Location.update({
              state: 'location',
              id: item?.id,
              data: payload,
            })
          }}
        />
      ),
    },
  ]

  return (
    <Table
      onSearchChange={(val) => {
        setSearchTerm(val)
      }}
      onPageChange={setPage}
      pageControlled={page}
      searchKeys={['locationName']}
      text="Location List"
      icon={booking}
      itemsPerPage={20}
      totalItems={totalItems}
      totalPages={totalPages}
      columns={columns}
      data={Locations}
      loading={loading}
      actions={[
        {
          key: 'edit',
          icon: edit,
          onClick: (item) => {
            navigate(`/admin/location-setup/${item.id}`, { state: item })
            scrollToTop()
          },
        },
      ]}
    />
  )
}

export default LocationSetupList
